module.exports = __webpack_public_path__ + "img/passion_jewelry.6be76fc7.png";